<template>
  <div class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item>
        <el-date-picker v-model="searchInfo.yearMonth" type="month" value-format="yyyy-MM" placeholder="请选择考勤月份"
          :clearable="false">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchInfo.projectId" placeholder="请选择所属项目" filterable clearable @change="projectChange">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchInfo.type" placeholder="请选择考勤类型" filterable clearable>
          <el-option v-for="item in types" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="content">
      <div class="left">
        <div class="statistics">
          <div class="name">出勤总人次</div>
          <div class="count">{{ statistic.signNum || 0 }}</div>
        </div>

        <div class="statistics-middle">
          <div>
            <div class="title">实名工人</div>
            <div>
              <div><span class="count">{{ statistic.onSignNum || 0 }}</span>人次</div>
              <img src="@/assets/img/attendance/img.png">
            </div>
          </div>
          <div>
            <div class="title">劳务班组</div>
            <div>
              <div><span class="count">{{ statistic.offSignNum || 0 }}</span>人次</div>
              <img src="@/assets/img/attendance/img1.png">
            </div>
          </div>
        </div>

        <div class="statistics color">
          <div class="name">加班总人次</div>
          <div class="count">{{ statistic.overtimeNum || 0 }}</div>
        </div>
        <div class="statistics color">
          <div class="name">加班总时长(小时)</div>
          <div class="count">{{ statistic.overtimeHours || 0 }}</div>
        </div>
      </div>
      <div class="right">
        <!-- <div>
            <div @click="prev"></div>
            <div>{{currentMonth}}</div>
            <div @click="next"></div>
          </div> -->

        <div class="calendar-header">
          <span>{{ $dayjs(currentMonth).format('YYYY年MM月') }}</span>
        </div>
        <div class="calendar-body">
          <div class="week" v-for="(item, ind) in week" :key="'c' + ind">
            {{ item }}
          </div>
          <div class="item" v-for="(item, ind) in list" :key="'c2' + ind"
            :style="{ height: $dayjs(currentMonth).day() === 6 ? '105px' : '120px' }">
            <div v-if="item.day" class="item-ctt item-click">
              <p class="date"><span>{{+item.day.split('-')[2] }}</span></p>
              <div>
                <p class="num" v-if="item.signNum">签到 {{ item.signNum || 0 }}人</p>
                <p class="num" v-if="item.overtimeHours">加班 {{ item.overtimeHours || 0 }}小时</p>
              </div>
            </div>
            <div v-else class="item-ctt">
              <p class="date"></p>
              <p class="num"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Statistics',
  data() {
    return {
      searchInfo: {
        yearMonth: '',
        projectId: '',
        type: ''
      },

      statistic: {},
      list: [],
      week: ['日', '一', '二', '三', '四', '五', '六'],
      types: [{
        name: '自建工人',
        value: '1'
      },
      {
        name: '班组考勤',
        value: '2'
      }],
      currentMonth: ''

    }
  },
  computed: {

    projectList() {
      return this.$store.state.projectList
    }
  },

  created() {
    this.currentMonth = this.$dayjs().format('YYYY-MM')
    this.searchInfo.yearMonth = this.currentMonth
    if (this.$route.query.projectId || this.$route.query.yearMonth) {
      console.log(this.$route.query.projectId, this.$route.query.yearMonth, 'this.$route.query.projectId');
      this.searchInfo.projectId = this.$route.query.projectId
      this.searchInfo.yearMonth = this.$route.query.yearMonth
    }
    this.load()
  },
  methods: {
    projectChange(val) {
      if (!val) {
        this.searchInfo.projectId = ''
      }
    },

    onSearch() {
      this.currentMonth = this.searchInfo.yearMonth
      this.list = []
      this.load()
    },

    load() {
      this.$axios.get(this.$apis.laborManage.selectYhAttendanceCountByWeb, {
        ...this.searchInfo
      }).then((res) => {
        this.statistic = res
        this.formatList(res.list || [])
      })
    },

    formatList(arr) {
      this.list = arr
      const startLen = this.$dayjs(this.currentMonth).day()
      const totalLen = this.list.length + startLen > 35 ? 42 : 35
      const aStart = new Array(startLen)
      const aEnd = new Array(totalLen - this.list.length - startLen)
      aStart.length && aStart.fill({})
      aEnd.length && aEnd.fill({})
      this.list = aStart.concat(this.list)
      this.list = this.list.concat(aEnd)
    },

    changeMoth(num) {
      this.currentMonth = this.$dayjs(this.currentMonth).add(num, 'month').format('YYYY-MM')
    }
  }

}
</script>

<style scoped lang="scss">
.common-title {
  height: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  font-style: normal;
}

.common-count {
  font-family: DINCondensed, DINCondensed;
  font-weight: bold;
  font-size: 60px;
  color: #333333;
  text-align: center;
  font-style: normal;
}

.content {
  display: flex;
  min-height: calc(100% - 50px);

  .left {
    width: 300px;
    padding: 20px 10px;
    background: #FFFFFF;
    box-shadow: 0px 1px 2px 0px rgba(139, 172, 237, 0.1);
    border-radius: 20px;

    .statistics {
      @extend .common-title;
      width: 100%;
      height: auto;
      background: #D0E9FF;
      color: #398DE8;
      margin-bottom: 20px;

      .name {
        line-height: 40px;
      }

      .count {
        @extend .common-count;
        background: #F6FBFE;
        height: 110px;
        line-height: 100px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .color {
      margin-bottom: 30px;

      .name {
        font-weight: 600;
        color: #000000;
        background: #FFE8D7;
      }

      .count {
        height: 100px;
        background: RGBA(255, 244, 235, 1);
      }
    }

    .statistics-middle {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 236px;
      background: #F6FBFE;
      border-radius: 9px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      font-style: normal;
      padding: 0px 10px;
      margin-bottom: 41px;

      >div {
        flex: 1;
        padding: 28px 41px 0px 37px;

        &:nth-of-type(1) {
          border-bottom: 1px solid #E5F3FF;
        }

        .title {
          position: relative;
          margin-left: 21px;

          &::before {
            position: absolute;
            content: url('~@/assets/img/attendance/icon_index_zongshu.png');
            left: -30px;
            top: -6px;
          }
        }

        .count {
          display: inline-block;
          margin-right: 10px;
        }

        >div {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
        }
      }

      .count {
        font-family: DINCondensed, DINCondensed;
        font-weight: bold;
        font-size: 40px;
        color: #4A4A4A;
      }
    }
  }

  .right {
    flex: 1;
    background: #FFFFFF;
    box-shadow: 0px 1px 2px 0px rgba(139, 172, 237, 0.1);
    border-radius: 20px;
    margin-left: 30px;
    padding: 30px 79px 45px 81px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    font-style: normal;

    .calendar-header {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;

      span {
        padding: 0 47px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
        font-style: normal;
      }

      .unnormal {
        font-weight: 400;
        font-size: 12px;
        position: absolute;
        right: 0;
        top: 10px;
        padding: 0;

        &::before {
          position: absolute;
          content: '';
          width: 14px;
          height: 14px;
          background: red;
          left: -20px;
        }
      }
    }

    .calendar-body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      border-bottom: 1px solid #F1F1F1;

      .week {
        width: 14.28%;
        height: 40px;
        background: #FCFCFC;
        border: 1px solid #F1F1F1;
        padding: 10px 18px;
        text-align: right;
        border-bottom-color: transparent;

        &:first-child,
        &+.item:not(:nth-child(7n)) {
          border-right-width: 0;
        }
      }

      .item {
        flex-shrink: 0;
        width: 14.28%;
        height: 105px;

        .item-ctt {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          border: 1px solid #F1F1F1;
          border-bottom-color: transparent;
          padding: 20px 20px 11px 0;
          text-align: right;

          p {
            padding: 0 5px;
            line-height: 18px;

            &.date {
              width: 100%;
              height: 18px;
              font-size: 20px;
            }

            &.num {
              display: flex;
              justify-content: right;
              align-items: flex-end;
            }
          }
        }

        &:nth-child(n+15):nth-child(-n+21),
        &:nth-child(n+29):nth-child(-n+35),
        &:nth-child(n+43):nth-child(-n+49) {
          background: #FCFCFC;
        }

        &:first-child,
        &:not(:nth-child(7n)) {
          .item-ctt {
            border-right-width: 0;
          }
        }
      }
    }
  }
}
</style>
